module.exports = __webpack_public_path__ + "img/full0-min.7c89f0ba.png";